import React from 'react';

import PlanCard, { PlanCardVariant } from '../PlanCard/PlanCard';
import Icon, { Icons } from '@app/common/components/Icon';
import Note, { NoteType } from '@app/common/components/Note';
import { TariffPlan } from '@app/types/TariffPlan';
import { Subscription } from '@app/hooks/query/useSubscriptionData';
import { formatPriceDisplay } from '../../utils/planUtils';

import styles from './PlanConfirmationStep.module.scss';
import { SubscriptionBillingPeriod } from '@app/config';

interface PlanConfirmationStepProps {
    currentPlan: Subscription;
    selectedPlan: TariffPlan;
    accountType: string;
}

const PlanConfirmationStep: React.FC<PlanConfirmationStepProps> = ({ currentPlan, selectedPlan, accountType }) => {
    // Calculate the price difference for the warning message
    const newPrice = formatPriceDisplay(selectedPlan.price);

    return (
        <div className={styles.container}>
            <h3 className={styles.heading}>You are changing your current FLK plan from:</h3>
            <div className={styles.comparison}>
                <PlanCard
                    plan={currentPlan}
                    isCurrentPlan
                    billingFrequency={SubscriptionBillingPeriod.MONTHLY}
                    variant={PlanCardVariant.CONFIRMATION}
                    accountType={accountType}
                />

                <Icon icon={Icons.ARROW_RIGHT} className={styles.arrow} />

                <PlanCard
                    plan={selectedPlan}
                    billingFrequency={SubscriptionBillingPeriod.MONTHLY}
                    variant={PlanCardVariant.CONFIRMATION}
                    accountType={accountType}
                />
            </div>
            {/* TODO: Check if we want the note before the plan model change */}
            {/* 
            <div className={styles.warningSection}>
                <Note type={NoteType.WARNING2} title="Plan changes will be applied instantly.">
                    You will automatically be charged the new plan price of <strong>{newPrice}</strong>
                </Note>
            </div> */}
        </div>
    );
};

export default PlanConfirmationStep;
